import React, { useEffect, useState } from 'react';

const CursorGlowEffect = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isOverClickable, setIsOverClickable] = useState(false);

  useEffect(() => {
    const updateCursor = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
      
      // Check if the element or its parents are clickable
      const element = document.elementFromPoint(e.clientX, e.clientY);
      const isClickable = element?.closest('a, button, .clickable, [role="button"]') !== null;
      setIsOverClickable(isClickable);
    };

    window.addEventListener('mousemove', updateCursor);
    return () => window.removeEventListener('mousemove', updateCursor);
  }, []);

  return (
    <div
      className="pointer-events-none fixed inset-3 z-10"
      style={{
        background: `radial-gradient(circle 200px at ${position.x}px ${position.y}px,
          ${isOverClickable 
            ? 'rgba(139, 233, 253, 0.20)' // Ice blue for clickable elements
            : 'rgba(250, 204, 21, 0.20)'  // Original yellow for regular text
          },
          transparent 50%
        )`,
        mixBlendMode: 'difference'
      }}
    />
  );
};

export default CursorGlowEffect;